import React, { Component } from "react";
import { Tabs, Tab, Button, Spinner } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import RolesList from "./RolesList";
import CreateRoleModal from "./CreateRoleModal";
import AppContext from "../../Context/AppContext";
import apis from "../../services/apis";
import { toast } from "react-toastify";
import "./roles.css";

class SiteModuleContents extends Component {
  static contextType = AppContext;

  state = {
    pageTab: "site",
    showCreateRoleModal: false,
    refreshKey: Date.now(),
    moduleIds: {
      module: 0,
      contents: 0,
    },
    loadingModuleIds: false,
  };


getRoleLevel = () => {
    const { pageTab } = this.state;
    if (pageTab === "module") return "module";
    if (pageTab === "contents") return "content";
    return "site";
  };
  goToDashboard = () => {
    this.props.history.push("/dashboard");
  };

  /* ========= LOAD MODULE IDS (SERVICE BASED) ========= */
  loadModuleIds = async () => {
    const { applicationId, siteId } = this.context;
    const token = localStorage.getItem("keycloakToken");

    this.setState({ loadingModuleIds: true });

    try {
      const result = await apis.getModuleIds(applicationId, siteId, token);

      if (result?.code === "SUCCESS") {
        const parsed = JSON.parse(result.json);

        this.setState({
          moduleIds: {
            module: parsed?.applicationModuleTO?.moduleId || 0,
            contents: parsed?.moduleEntityTypeTO?.moduleId || 0,
          },
        });
      } else {
        toast.error(result?.message || "Failed to load module details");
      }
    } catch (err) {
      console.error("Module ID load error", err);
      toast.error("Unable to load module information");
    } finally {
      this.setState({ loadingModuleIds: false });
    }
  };



 

  handleCreateRole = () => {
    this.setState({ showCreateRoleModal: true });
  };



  render() {
    const {
      pageTab,
      showCreateRoleModal,
      refreshKey,
      loadingModuleIds,
    } = this.state;

    const { applicationId, siteId } = this.context;
    
    return (
  <div className="main-container">
    {/* Single unified card/container */}
    <div className="page-wrapper p-4">

      {/* Header + Create Button */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h1 className="page-title mb-1">Roles Management</h1>
          <p className="page-subtitle mb-0">
            Create roles and manage permissions.
          </p>
        </div>

        <div className="d-flex align-items-center gap-3">
          
          <Button
                  variant="link"
                  className="me-2"
                 onClick={this.goToDashboard}
                  >
                  Back to Dashboard
                  </Button>

          <Button variant="primary ml-4" onClick={this.handleCreateRole}>
            Create Role
          </Button>
        </div>
      </div>

      {/* Roles Table */}
      <div>
        <RolesList
          key={refreshKey}
          applicationId={applicationId}
          siteId={siteId}
          moduleId="189"
        />
      </div>

      {/* Create Role Modal */}
      <CreateRoleModal
        show={showCreateRoleModal}
        onHide={() => this.setState({ showCreateRoleModal: false })}
        roleLevel={this.getRoleLevel()}
        applicationId={applicationId}
        siteId={siteId}
        moduleId="189"
        onSuccess={() =>
          this.setState({
            showCreateRoleModal: false,
            refreshKey: Date.now(),
          })
        }
      />
    </div>
  </div>
);

  }
}

export default withRouter(SiteModuleContents);
